/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_1_WInputs */

const en_cp_cal_1_w = /** @type {(inputs: Cp_Cal_1_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week 0`)
};

const id_cp_cal_1_w = /** @type {(inputs: Cp_Cal_1_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minggu 0`)
};

/**
* | output |
* | --- |
* | "Week 0" |
*
* @param {Cp_Cal_1_WInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_1_w = /** @type {((inputs?: Cp_Cal_1_WInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_1_WInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_1_w(inputs)
	return en_cp_cal_1_w(inputs)
});